import React, { useState, useEffect, useContext, useRef } from "react";

import InsightTableRow from "./InsightTableRow";

export default function PortfolioInspectorTable({onWorkspaceRequested})
{
	
	
	
	const data =
	[
	    {
	        id: 1,
	        level: 0,
	        expanded: true,

	        name: "Broadcasting House",

	        trend: "▁▂▃▄▅▆▇█",

	        insightTotal: 42,
	        high: 12,
	        medium: 19,
	        low: 11,

	        assetTotal: 124,
	        good: 96,
	        fair: 21,
	        poor: 5,
	        critical: 2,

	        subs:
	        [
	            {
	                id: 11,
	                level: 1,
	                expanded: true,

	                name: "Ground Floor",

	                trend: "▂▃▄▅▆▇█",

	                insightTotal: 15,
	                high: 5,
	                medium: 6,
	                low: 4,

	                assetTotal: 41,
	                good: 34,
	                fair: 5,
	                poor: 1,
	                critical: 1,

	                subs:
	                [
	                    {
	                        id:111,
	                        level:2,
	                        expanded:false,

	                        name:"Reception",

	                        trend:"▂▃▄▅▆",

	                        insightTotal:4,
	                        high:2,
	                        medium:1,
	                        low:1,

	                        assetTotal:9,
	                        good:7,
	                        fair:2,
	                        poor:0,
	                        critical:0,
							subs:[]
	                    },
	                    {
	                        id:112,
	                        level:2,
	                        expanded:false,

	                        name:"Main Lobby",

	                        trend:"▃▄▅▆▇",

	                        insightTotal:5,
	                        high:1,
	                        medium:3,
	                        low:1,

	                        assetTotal:12,
	                        good:10,
	                        fair:2,
	                        poor:0,
	                        critical:0							,
							subs:[]
	                    },
	                    {
	                        id:113,
	                        level:2,
	                        expanded:false,

	                        name:"Meeting Room 1",

	                        trend:"▁▂▃▄▅",

	                        insightTotal:6,
	                        high:2,
	                        medium:2,
	                        low:2,

	                        assetTotal:20,
	                        good:17,
	                        fair:1,
	                        poor:1,
	                        critical:1							,
							subs:[]
	                    }
	                ]
	            },

	            {
	                id:12,
	                level:1,
	                expanded:false,

	                name:"Level 01",

	                trend:"▂▂▃▄▅▆",

	                insightTotal:14,
	                high:4,
	                medium:6,
	                low:4,

	                assetTotal:43,
	                good:35,
	                fair:6,
	                poor:1,
	                critical:1,

	                subs:
	                [
	                    {
	                        id:121,
	                        level:2,
	                        expanded:false,

	                        name:"Open Plan Office",

	                        trend:"▂▃▄▅",

	                        insightTotal:8,
	                        high:2,
	                        medium:4,
	                        low:2,

	                        assetTotal:26,
	                        good:22,
	                        fair:3,
	                        poor:1,
	                        critical:0							,
							subs:[]
	                    },
	                    {
	                        id:122,
	                        level:2,
	                        expanded:false,

	                        name:"Boardroom",

	                        trend:"▃▄▅▆",

	                        insightTotal:6,
	                        high:2,
	                        medium:2,
	                        low:2,

	                        assetTotal:17,
	                        good:13,
	                        fair:3,
	                        poor:0,
	                        critical:1							,
							subs:[]
	                    }
	                ]
	            }
	        ]
	    },

	    {
	        id:2,
	        level:0,
	        expanded:false,

	        name:"Media Village",

	        trend:"█▇▆▅▄▃▂▁",

	        insightTotal:19,
	        high:4,
	        medium:9,
	        low:6,

	        assetTotal:81,
	        good:63,
	        fair:14,
	        poor:3,
	        critical:1,
			subs:[]
	    },

	    {
	        id:3,
	        level:0,
	        expanded:false,

	        name:"Pinkston",

	        trend:"▂▃▄▅▆▇▇█",

	        insightTotal:27,
	        high:8,
	        medium:12,
	        low:7,

	        assetTotal:57,
	        good:48,
	        fair:7,
	        poor:1,
	        critical:1,
			subs:[]
	    },

	    {
	        id:4,
	        level:0,
	        expanded:false,

	        name:"Holborn",

	        trend:"▂▂▃▄▅▅▆▇",

	        insightTotal:13,
	        high:3,
	        medium:7,
	        low:3,

	        assetTotal:38,
	        good:31,
	        fair:6,
	        poor:1,
	        critical:0,
			subs:[]
	    }
	];

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",

                height: "100%",

                background: "white",

                borderRadius: "10px",

                overflow: "hidden",
				marginLeft:'20px',
				marginRight:'20px'
            }}
        >

		<div
		    style={{
		        display: "flex",
		        alignItems: "center",

		        minHeight: "42px",

		        padding: "0px 20px",

		        background:
		            "linear-gradient(180deg,#364152 0%,#1f2937 60%,#111827 100%)",

		        color: "white",

		        fontSize: "12px",

		        fontWeight: 700,

		        borderBottom:
		            "1px solid rgba(255,255,255,.08)"
		    }}
		>

		    <div
		        style={{
		            width: "340px",
		            flexShrink: 0,

		            paddingLeft: "22px"
		        }}
		    >
		        PORTFOLIO
		    </div>

		    <div
		        style={{
		            flex: 2,
		            textAlign: "center"
		        }}
		    >
		        TREND
		    </div>

		    <div
		        style={{
		            flex: 3,
		            textAlign: "center"
		        }}
		    >
		        INSIGHTS
		    </div>

		    <div
		        style={{
		            flex: 4,
		            textAlign: "center"
		        }}
		    >
		        ASSET HEALTH
		    </div>

		</div>

			{/*==================================================*/}
			{/* Sub Header                                       */}
			{/*==================================================*/}

			<div
			    style={{
			        display: "flex",
			        alignItems: "center",

			        height: "28px",

			        padding: "0px 20px",

			        background: "#1f2937",

			        color: "#cbd5e1",

			        fontSize: "11px",

			        fontWeight: 600,

			        borderBottom:
			            "1px solid rgba(255,255,255,.05)"
			    }}
			>

			    <div
			        style={{
			            width: "420px",
			            flexShrink: 0
			        }}
			    />

			    <div style={{ flex: 2 }}/>

			    <div
			        style={{
			            flex: 3,

			            display: "flex",

			            justifyContent: "space-evenly"
			        }}
			    >
			        <span>Total</span>
			        <span>High</span>
			        <span>Med</span>
			        <span>Low</span>
			    </div>

			    <div
			        style={{
			            flex: 4,

			            display: "flex",

			            justifyContent: "space-evenly"
			        }}
			    >
			        <span>Total</span>
			        <span>Good</span>
			        <span>Fair</span>
			        <span>Poor</span>
			        <span>Crit</span>
			    </div>

			</div>

            {/*==================================================*/}
            {/* Rows                                              */}
            {/*==================================================*/}

            <div
                style={{
                    flex: 1,

                    overflowY: "auto"
                }}
            >

                {
                    data.map((item, index) => (
                       
                            <InsightTableRow
                                key={item.id}
								row={index}
								onWorkspaceRequested={onWorkspaceRequested}
                                {...item}
                            />
                    ))
                }

            </div>

        </div>

    );
}